import { GradientButton } from "@/components/common";
import { useNavigate } from 'react-router-dom';

interface CallToActionProps {
    title?: string;
}

const CallToAction: React.FC<CallToActionProps> = ({ title }) => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/contact-us');
    };

    return (
        <div className="relative flex items-center justify-center px-6 py-12 md:px-8 md:py-28 mt-16 mb-12 overflow-hidden">

            {/* Dark base */}
            <div className="absolute inset-0 bg-[#080c14]" />

            {/* Ambient glow blobs */}
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute top-[10%] left-[5%] w-[280px] h-[220px] sm:w-[500px] sm:h-[400px] rounded-full bg-indigo-600/10 blur-[80px] sm:blur-[120px]" />
                <div className="absolute bottom-[15%] right-[5%] w-[220px] h-[180px] sm:w-[420px] sm:h-[340px] rounded-full bg-sky-500/10 blur-[80px] sm:blur-[120px]" />
                <div className="absolute top-0 left-[40%] w-[160px] h-[120px] sm:w-[300px] sm:h-[200px] rounded-full bg-pink-500/5 blur-[60px] sm:blur-[100px]" />
            </div>

            {/* Subtle grid overlay */}
            <div className="pointer-events-none absolute inset-0 opacity-[0.03] bg-[linear-gradient(rgba(99,102,241,1)_1px,transparent_1px),linear-gradient(90deg,rgba(99,102,241,1)_1px,transparent_1px)] bg-[size:60px_60px]" />

            {/* Content */}
            <div className="relative z-10 text-center space-y-8 max-w-4xl mx-auto">
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white drop-shadow-lg" style={{ lineHeight: "1.5" }}>
                    {title}
                </h3>
                <div className="flex justify-center mt-4">
                    <GradientButton onClick={handleContactClick}>
                        Contact Us
                    </GradientButton>
                </div>
            </div>
        </div>
    );
};

export default CallToAction;